import { render, staticRenderFns } from "./WhatsappNumberApplication.vue?vue&type=template&id=0c28fe62&scoped=true&"
import script from "./WhatsappNumberApplication.vue?vue&type=script&lang=js&"
export * from "./WhatsappNumberApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c28fe62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c28fe62')) {
      api.createRecord('0c28fe62', component.options)
    } else {
      api.reload('0c28fe62', component.options)
    }
    module.hot.accept("./WhatsappNumberApplication.vue?vue&type=template&id=0c28fe62&scoped=true&", function () {
      api.rerender('0c28fe62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamInbox/WhatsappNumberApplication.vue"
export default component.exports